import { SizableText, styled } from '@my/ui'

export const SectionTitle = styled(SizableText, {
  tag: 'h2',
  size: '$6',
  fow: '600',
  $gtXs: {
    size: '$9',
    fow: '600'
  },
})

export const BlockTitle = styled(SizableText, {
  tag: 'h2',
  size: '$5',
  fow: '600',
  $gtXs: {
    size: '$8',
    fow: '600'
  },
})

export const H1 = styled(SizableText, {
  tag: 'h1',
  size: '$5',
  fow: '600',
  $gtXs: {
    size: '$9',
    fow: '600'
  },
})

export const H2 = styled(SizableText, {
  tag: 'h2',
  size: '$5',
  fow: '600',
  $gtXs: {
    size: '$8',
    fow: '600'
  },
})

export const H3 = styled(SizableText, {
  tag: 'h3',
  size: '$5',
  fow: '600',
  $gtXs: {
    size: '$7',
    fow: '600'
  },
})

export const H4 = styled(SizableText, {
  tag: 'h4',
  size: '$4',
  fow: '600',
  $gtXs: {
    size: '$6',
    fow: '600'
  },
})

export const H5 = styled(SizableText, {
  tag: 'h5',
  size: '$4',
  fow: '600',
  $gtXs: {
    size: '$5',
    fow: '600'
  },
})

export const H6 = styled(SizableText, {
  tag: 'h6',
  size: '$4',
  fow: '600',
  $gtXs: {
    size: '$5',
    fow: '600'
  },
})
